import { Card as _Card, CardProps } from 'antd5';
import { StyledCard } from './Card.style';

export function Card(props: CardProps) {
  return <StyledCard {...props} />;
}

export const Meta = _Card.Meta;
